import React, { useState } from "react";
import styles from "./SubmitButton.module.css";
import TextComponent from "../textComponent/TextComponent";

//   inputIcon:InputIcon,
const SubmitButton = (props) => {
  const [touched, setTouched] = useState(false);
  const btnTouched = () => {
    setTouched(!touched);
  };
  const btnRelease = () => {
    setTouched(false);
  };

  // console.log("gradientBtn", props?.gradientBtn);

  return (
    <div className={` ${props?.btnContainerClass} ${styles.btn_container}`}>
      <button
        onMouseDown={btnTouched}
        onMouseUp={btnRelease}
        disabled={props?.disabled}
        className={` ${props?.btnClass}  ${
          props?.primary
            ? styles.primaryBtn
            : props?.secondary
            ? styles.secondaryBtn
            : styles.modalCancelBtn
        }  `}
        onClick={props?.onClick}
        style={props?.style}
      >
        {props.leftIcon && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "5px",
            }}
          >
            {props.leftIcon}
          </div>
        )}
        <span
          className={`${
            props?.primary
              ? styles.primaryBtnText
              : props?.secondary
              ? styles.secondaryBtnText
              : styles.modalCancelBtnText
          }`}
          style={props?.textStyle}
        >
          {props?.title}
        </span>
        {props.rightIcon}
      </button>
    </div>
  );
};

export default SubmitButton;
